import { AuthContextType } from '@auth/AuthProvider';
import NetworkController, { HTTPMethod, HTTPRequest, HTTPResponse } from '@data/controller/NetworkController';
import { SongAttributes, StreamingPlatform } from '@data/interfaces/song.interface';

export type SongSearchResultsResponse = {
  results: SongAttributes[],
  platform: StreamingPlatform
};

type MatchResultsResponse = {
  matchResults: Partial<Record<StreamingPlatform, SongAttributes>>;
};

export default class SongSearchController {
  private static baseURL: string = process.env.REACT_APP_SANCTUARY_API_URL || "";

  static async searchSongs(query: string, auth: AuthContextType): Promise<HTTPResponse<SongSearchResultsResponse>> {
    return await NetworkController.performRequestAt<SongSearchResultsResponse>(
      this.baseURL,
      new HTTPRequest(
        HTTPMethod.GET,
        `/v1/search/songs/streaming?query=${encodeURIComponent(query)}`
      ),
      auth.consumeRefreshToken
    );
  }

  static async fetchMatchResults(isrc: string, skipPlatform: StreamingPlatform, auth: AuthContextType): Promise<HTTPResponse<MatchResultsResponse>> {
    return await NetworkController.performRequestAt<MatchResultsResponse>(
      this.baseURL,
      new HTTPRequest(
        HTTPMethod.GET,
        `/v1/search/songs/streaming/match?isrc=${encodeURIComponent(isrc)}&skipPlatforms=${encodeURIComponent(skipPlatform)}`
      ),
      auth.consumeRefreshToken
    );
  }
}
